import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokeGetService, invokePostService, setDashboardRefresh, setReRender, toggleRightDrawer } from "../../../store/global/actions.js";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { getDetailsFromUrl } from '../../../services/blueprint.js'
import { getViews } from "../../../store/views/selectors.js";
import { editView } from "../../../store/views/actions.js";
import { getRightDrawerStatus } from '../../../store/global/selectors.js';
import { useHistory } from 'react-router-dom';
import { hyperlinkQueryParametersSchema, uiTypeChildren } from '../../../config/fields.js';
import { hyperlinkTypes } from '../../../config/common.js';
import { Box, Grid } from '@material-ui/core';
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import JsonTableEditor from '../../atoms/jsonFormEditor/JsonTableEditor.js';
import { clearFormErrors, showJsonEditorCustomValidationErrors, updateViewSchema } from '../../../utils/DashboardBuilder.js';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader.js';
const shortUUiD = require("short-uuid");

const options = {
    form_name_root: "row_operation_hyperlink",
    show_errors: "interaction",

    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
    disable_array_reorder: true,
}

export default function TableRowHyperlink({ onClose, forceCancel, noFloatButton, action, onCompletion, selectedSchema, index, selectedWidget }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const editorWrapper = useRef()

    const selectedView = useSelector(getViews);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const editorId = index ? `table_row_hyperlink_form_${index}` : "table_row_hyperlink_form_";
    const { slug, blueprintId } = getDetailsFromUrl();


    const [loading, setLoading] = useState(true)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);
    const [clusterlets, setClusterlets] = useState([])
    const [jsonEditordata, setJSonEditorData] = useState([]);
    const [allViews, setAllViews] = useState([]);
    const [editorObj, setEditorObj] = useState(null);



    useEffect(() => {
        loadClusterlets()
    }, [])


    const loadClusterlets = () => {
        Promise.all([
            dispatch(invokeGetService('getSystemModelData', [])),
            dispatch(invokeGetService('getBlueprintConstructs', []))
        ]).then(([response, blueprintConstructs]) => {
            setAllViews(blueprintConstructs.data?.views);
            setSchemaValues(generateSchemaData(selectedSchema));
            setClusterlets(response.data.clusterlets.filter(c => c.type === 2 || c.type === 3))
            setLoading(false)
        })
    }

    const generateSchemaData = (selectedSchema) => {
        let hyperlinkType = {}

        if (selectedSchema !== undefined && selectedSchema !== null) {
            hyperlinkType.defaultvalue = selectedSchema?.defaultvalue ? selectedSchema.defaultvalue : "";
            if (selectedSchema.viewname !== undefined) {
                hyperlinkType.viewname = selectedSchema.viewname;
                hyperlinkType.instance = selectedSchema.instance;
                hyperlinkType.urlView = "urlView"
                hyperlinkType.queryParameters = (selectedSchema.queryparams && selectedSchema.queryparams?.length > 0 ) ? selectedSchema.queryparams : [{Key: "", Value: ""}];
            }


            if (selectedSchema.clusterlettype !== undefined) {
                hyperlinkType.clusterlettype = selectedSchema.clusterlettype;
                hyperlinkType.instance = selectedSchema.instance;
                hyperlinkType.urlClusterlet = "urlClusterlet";
                hyperlinkType.queryParameters = (selectedSchema.queryparams && selectedSchema.queryparams?.length > 0 ) ? selectedSchema.queryparams : [{Key: "", Value: ""}];
            }

            if (selectedSchema.url !== undefined) {
                hyperlinkType.url = selectedSchema.url;
                hyperlinkType.urlExternal = "urlExternal";
            }
        } else {
            hyperlinkType = {"select": "select"}
        }
        let schemaValues = {
            'description': selectedSchema?.desc ? selectedSchema?.desc : "",
            'hyperlinkType': hyperlinkType
        };

        return schemaValues
    }


    const commonProperties = {
        instance: {
            title: 'Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },
        defaultvalue: {
            title: 'Link to text',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },
    };

    const urlViewSchema = {
        viewname: {
            title: 'View name',
            type: "string",
            enumSource: [{
                source: [{ title: "Select view", value: 'select' }, ...allViews.map(item => ({ title: item.name, value: item._id }))],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                input_width: '200px',
                layout: 'grid',
                grid_columns: 6
            }
        },
        instance: commonProperties.instance,
    }

    const urlClusterletSchema = {
        clusterlettype: {
            title: 'Clusterlet type',
            type: "string",
            enumSource: [{
                source: [{ title: "Select clusterlet type", value: 'select' }, ...clusterlets.map(item => ({ title: item.name, value: item._id }))],
                title: "{{item.title}}",
                value: "{{item.value}}"
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            }
        },
        instance: commonProperties.instance,
    }

    const urlExternalSchema = {
        url: {
            title: "Url",
            type: "string",
            options: {
                layout: 'grid',
                grid_columns: 12
            }
        },
    }

    const hyperlinkTypesSchema = [{ title: "Select url type", value: "select" }, ...hyperlinkTypes].map(item => {
        const queryParameters = hyperlinkQueryParametersSchema();
        let singleSchema = {
            title: item.title,
            type: "object",
            default: item.value,
            properties: {
                [item.value]: {
                    default: item.value,
                    type: 'string',
                    options: { hidden: true }
                },
            },
            additionalProperties: false
        }

        if (item.value === "urlView") {
            singleSchema = {
                ...singleSchema, properties: {
                    ...singleSchema.properties, ...urlViewSchema, defaultvalue: commonProperties.defaultvalue, queryParameters
                }
            }
        }

        if (item.value === "urlClusterlet") {
            singleSchema = {
                ...singleSchema, properties: {
                    ...singleSchema.properties, ...urlClusterletSchema, defaultvalue: commonProperties.defaultvalue, queryParameters
                }
            }
        }

        if (item.value === "urlExternal") {
            singleSchema = {
                ...singleSchema, properties: {
                    ...singleSchema.properties, ...urlExternalSchema, defaultvalue: commonProperties.defaultvalue
                }
            }
        }

        // singleSchema.properties = { ...singleSchema.properties, defaultvalue: commonProperties.defaultvalue, }
        singleSchema.properties = { ...singleSchema.properties}

        return singleSchema
    });


    const schema = {
        type: 'object',
        required: ['hyperlinkType'],
        options: {
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: {
            description: {
                title: 'Description',
                type: 'string',
                options: {
                    layout: 'grid',
                    grid_columns: 12
                },
            },
            hyperlinkType: {
                title: 'Hyperlink type',
                oneOf: [...hyperlinkTypesSchema],
                options: {
                    input_width: '200px',
                    disable_properties: true,
                    layout: 'grid',
                    grid_columns: 12
                }
            },
        },
    }


    // Style the query parameters in the form
    const handleHyperlinkQueryParametersInForm = () => {
        const containers = document.querySelectorAll('[data-schemapath="row_operation_hyperlink.hyperlinkType.queryParameters"]');
        if (containers) {
        containers?.forEach((container, index) => {
        
            // 1. Change grid size from col-md-12 → col-md-6
            container.classList.remove("col-md-12");
            container.classList.add("col-md-8");
        
            // 2. Change Add Row button text
            const addBtn = container.querySelector(".json-editor-btn-add");
            if (addBtn) {
            addBtn.title = "";
            const span = addBtn.querySelector("span");
            if (span) span.textContent = " Add query parameter";
            }
        
            // 3. Insert label "Custom arguments" before the table if not present
            if (!document.getElementById(`custom-arguments-label-${index}`)) {
            const table = container.querySelector("table");
            if (table) {
                const label = document.createElement("div");
                label.id = `custom-arguments-label-${index}`;
                label.textContent = "Add more query parameters for the hyperlink";
                label.style.marginBottom = "5px";
                label.style.marginTop = "8px";
                table.parentNode.insertBefore(label, table);
            }
            }
        
        })

        }
    }

    const onChangeJsonEditor = (data, jsonEditor) => {
        handleHyperlinkQueryParametersInForm();
        setJSonEditorData(data)
        setEditorObj(jsonEditor);
    }


    const onUpdate = () => {
        clearFormErrors();
        const editorValidationErrors = editorObj.validate();
        const customValidationErrors = customValidation(jsonEditordata);
        showJsonEditorCustomValidationErrors(customValidationErrors)
        if ([...editorValidationErrors, ...customValidationErrors].length > 0) {
            editorObj.showValidationErrors(editorValidationErrors);
            return;
        }
        setIsUpdating(true);
        let selectedItem = { ...selectedWidget }
        if (selectedWidget?.type === 'table') {
            let dropDownChild = selectedItem.children.find(field => field.type == 'drop-down')

            if (dropDownChild === undefined) {
                let uiTypeChildrenObj = uiTypeChildren();
                uiTypeChildrenObj['table'] ? selectedItem.children = [...selectedItem.children, ...uiTypeChildrenObj['table']] : selectedItem.children = selectedItem.children;
            }

            let hyperlinkData = jsonEditordata.hyperlinkType
            let queryParams = hyperlinkData?.queryParameters?.filter(item => item?.Key !== "" && item?.Value !== "") || [];
            let name = hyperlinkData.defaultvalue.split(" ").join("");

            let hyperlinkObj = {
                name: name,
                desc: jsonEditordata?.description,
                type: "string",
                title: hyperlinkData.defaultvalue,
                defaultvalue: hyperlinkData.defaultvalue,
                category: "field",
                visible: true,
                children: [],
            }

            if (hyperlinkData.viewname !== undefined) {
                hyperlinkObj.viewname = hyperlinkData.viewname;
                hyperlinkObj.instance = hyperlinkData.instance
            }

            if (hyperlinkData.clusterlettype !== undefined) {
                hyperlinkObj.clusterlettype = hyperlinkData.clusterlettype;
                hyperlinkObj.instance = hyperlinkData.instance;
            }

            if( (hyperlinkData.viewname || hyperlinkData.clusterlettype) &&  queryParams?.length > 0){
                hyperlinkObj.queryparams = queryParams;
            }else{
                delete hyperlinkObj.queryparams;
            }

            if (hyperlinkData.url !== undefined) {
                hyperlinkObj.url = hyperlinkData.url;
            }


            if (selectedSchema === undefined) {
                hyperlinkObj.id = shortUUiD.generate();

                const index = selectedItem.children.findIndex(item => item.type === "drop-down");

                if (index !== -1) {
                    selectedItem.children[index].children.push(hyperlinkObj)
                }
            } else {
                hyperlinkObj.id = selectedSchema?.id;

                const index = selectedWidget.children.findIndex(item => item.type === "drop-down");

                const existingIndex = selectedWidget.children[index].children.findIndex(item => item.id === selectedSchema?.id);
                if (existingIndex !== -1) {
                    selectedWidget.children[index].children[existingIndex] = hyperlinkObj;
                }
            }
        }

        dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: {id: selectedWidget, ...selectedItem} }));
        const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedItem.id, updatedData: selectedItem });
        handleViewUpdate(updatedView);
    }

    const handleViewUpdate = (updatedView) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [selectedView._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                onCompletion('Widget', action === 'create' ? 'add' : 'edit');
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                }
            }
        })
    }


    const customValidation = (data) => {
        let errors = [];
        let hyperlinkData = data.hyperlinkType;

        if (!hyperlinkData?.urlView && !hyperlinkData?.urlClusterlet && !hyperlinkData.urlExternal) {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType",
                isSwitcher: true,
                property: 'format',
                message: "Hyperlink Type is required",
            })
        }

        if (hyperlinkData.urlView == undefined && hyperlinkData.urlClusterlet == undefined && hyperlinkData.urlExternal == undefined) {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType",
                property: 'format',
                message: "Please select a hyperlink type"
            })
        }


        if (hyperlinkData.viewname != undefined && hyperlinkData.viewname == "select") {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType.viewname",
                property: 'format',
                message: "View name is required"
            })
        }

        if (hyperlinkData.clusterlettype != undefined && hyperlinkData.clusterlettype == "select") {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType.clusterlettype",
                property: 'format',
                message: "Clusterlet type is required"
            })
        }

        if (hyperlinkData.defaultvalue != undefined && hyperlinkData.defaultvalue == "") {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType.defaultvalue",
                property: 'format',
                message: "Please enter a text to link"
            })
        }

        if (hyperlinkData.url != undefined && hyperlinkData.url == "") {
            errors.push({
                path: "row_operation_hyperlink.hyperlinkType.url",
                property: 'format',
                message: "Please enter a url"
            })
        }

        return errors;
    }

    useEffect(() => {
        if (editorWrapper?.current) {
            const grid1 = editorWrapper?.current?.querySelector('.MuiGrid-spacing-xs-1');
            const grid2 = editorWrapper?.current?.parentNode

            if (grid1) grid1.style.margin = 0;
            if (grid2) grid2.style.margin = 0;
        }
    }, [editorWrapper])

    return (
        <>
            {loading && <SkeletonLoader isLabelled type='form' rows={4} />}
            {!loading && <Box style={{ width: "100%" }} ref={editorWrapper}>
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} onChangeJsonEditor={onChangeJsonEditor} editorId={editorId} />
            </Box>}
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginTop: '30vh' } : { display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} noFloatButton={noFloatButton} forceCancel={forceCancel} content={isUpdating ? "Updating.." : "Update"} onUpdate={onUpdate} onCancel={onClose} />
            </Grid>
        </>
    )
}